import React from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePageHeader } from "../../context/LayoutContext";
import CameraEnhanceIcon from "@mui/icons-material/CameraEnhance";
import { useAuthContext } from "../../context/AuthContext";
import BodycamOnboardingPanel from "../../shared/components/BodycamOnboardingPanel";

const ConnectBodycam: React.FC = () => {
  const navigate = useNavigate();
  const { organizationId } = useAuthContext();

  usePageHeader({
    title: "Connect Bodycam",
    subtitle:
      "Select your vendor and enter credentials to securely sync evidence",
    icon: <CameraEnhanceIcon />,
  });

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: "80vh",
        py: 4,
        maxWidth: { xs: 600, xxl: 750, uhd: 900 },
      }}
    >
      <BodycamOnboardingPanel
        stationId={organizationId!}
        onReturnHome={() => navigate("/")}
      />
    </Container>
  );
};

export default ConnectBodycam;
export { ConnectBodycam };
